// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3K03c","log":"ModalInventoryLogs_log__16T5K","date":"ModalInventoryLogs_date__2M5Pj","userName":"ModalInventoryLogs_userName__3WcgO"};